import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Buffer } from "buffer";

@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor{
    userId!:string;
    private actions: string[]=['POST','PUT','DELETE']
    intercept(req :HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
        //  const userId = sessionStorage.getItem('UserId')==null? '0': (sessionStorage.getItem('UserId')==undefined?'0':sessionStorage.getItem('UserId') )
        //  userId='0'
        const user = sessionStorage.getItem('UserId');
        this.userId= user !== null ? JSON.parse(user):'0';

        // const clonedRequest3 = req.clone({setHeaders:{"Authorization":Buffer.from("Ouinetkeyid:Ouinetkeyvalue").toString('base64')}})
        const clonedRequest3 = req.clone({setHeaders:{"Authorization":"Basic T3VpbmV0a2V5aWQ6T3VpbmV0a2V5dmFsdWU="}})
        return next.handle(clonedRequest3);
    }
}